import {User} from 'src/app/shared/models/user.model';
import {AlertStatus, InquiryTypeSet} from 'src/app/shared/models/inquiry-type-set.model';
import {Alert} from 'src/app/customer/models/alert.model';
import {SmsAlert} from 'src/app/customer/models/sms-alert.model';
import {LengthAwarePaginator} from '@ratespecial/core';


export class UpdateUser {
  static readonly type = '[Session] Update User';

  constructor(public user: User) {
  }
}

export class UpdateIsAuthenticated {
  static readonly type = '[Session] Update isAuthenticated';

  constructor(public isAuthenticated: boolean) {
  }
}

export class UpdateInquiryTypes {
  static readonly type = '[Session] Update inquiryTypes';

  constructor(public types: InquiryTypeSet) {
  }
}

/**
 * This is for updating dashboard alerts.  The could be for any customer.  For customer detail alerts, see CustomerState
 */
export class UpdateAlerts {
  static readonly type = '[Session] Update alerts';

  constructor(
    public status: AlertStatus,
    public inquiryType: string,
    public alerts: LengthAwarePaginator<Alert> | LengthAwarePaginator<SmsAlert>,
  ) {
  }
}

/**
 * Fetch a page of dashboard alerts for the given category, unless it is already cached in state.  Pass force to
 * bypass the cache, such as after an alert is hidden.
 */
export class FetchAlerts {
  static readonly type = '[Session] Fetch alerts';

  constructor(
    public status: AlertStatus,
    public inquiryType: string,
    public page: number,
    public force: boolean = false,
  ) {
  }
}

export class FetchDownsellPricepoints {
  static readonly type = '[Session] Fetch downsell pricepoints';

  constructor(public force: boolean = false) {
  }
}

export class FetchCancelReasons {
  static readonly type = '[Session] Fetch cancel reasons';

  constructor(public force: boolean = false) {
  }
}

export class FetchRefundReasons {
  static readonly type = '[Session] Fetch refund reasons';

  constructor(public force: boolean = false) {
  }
}

export class FetchCloseableInquiryTypes {
  static readonly type = '[Session] Fetch closeable inquiry types';

  constructor(public force: boolean = false) {
  }
}

export class ClearState {
  static readonly type = 'ClearState';

  constructor() {
  }
}

/**
 * Fetch a LinkTrust campaign by CID, unless it is already cached in state.  Campaigns are shared by many customers, so
 * they are kept for the whole session.  Pass force to bypass the cache.
 */
export class FetchCampaign {
  static readonly type = '[Session] Fetch campaign';

  constructor(
    public cid: number,
    public force: boolean = false,
  ) {
  }
}
